export const QUERY_KEYS = {
  users: {
    getList: '유저조회',
    getMe: '내정보조회',
    createUser: '유저생성',
    updateUser: '유저수정',
    updateProfile: '프로필수정',
    deleteUser: '유저삭제',
    checkLoginId: '로그인ID중복체크',
    changePassword: '비밀번호변경',
  },
  sites: {
    getNextAvailableId: '사이트다음ID조회',
    checkDuplication: '사이트중복체크',
    getList: '사이트조회',
    getDetail: '사이트상세조회',
    getStats: '사이트통계조회',
    checkAccess: '사이트접근권한확인',
    createSite: '사이트생성',
    updateSite: '사이트수정',
    deleteSite: '사이트삭제',

    // 매니저 관리
    getManagers: '사이트매니저조회',
    addManager: '사이트매니저추가',
    removeManager: '사이트매니저제거',

    // 모터 관리
    resetMotor: '모터리셋',

    // 사진 관리
    getPhotos: '사이트사진조회',
    uploadPhoto: '사진업로드',
    deletePhoto: '사진삭제',

    // 어드민 전용
    getAdminLogs: (page: number, limit: number) =>
      ['어드민사이트로그조회', page, limit] as const,
  },
  dashboard: {
    // 기존 쿼리 키들
    motorStatus: (siteId: string) => ['대시보드', '모터상태', siteId] as const,
    waterLevelChart: (siteId: string, period: string) =>
      ['대시보드', '수위차트', siteId, period] as const,
    siteDetails: (siteId: string) => ['대시보드', '현장정보', siteId] as const,
    errorStatus: (siteId: string) => ['대시보드', '에러상태', siteId] as const,
    siteDashboard: (siteId: string) => ['대시보드', '통합', siteId] as const,

    // 현장 종합 상태 조회 쿼리 키
    comprehensiveStatus: (siteId: string) =>
      ['대시보드', '종합상태', siteId] as const,

    // 🚀 새로운 세분화된 쿼리 키들
    basicInfo: (siteId: string) => ['사이트', '기본정보', siteId] as const,
    realtimeStatus: (siteId: string) =>
      ['사이트', '실시간상태', siteId] as const,
    motorStats: (siteId: string) => ['사이트', '모터통계', siteId] as const,
    alerts: (siteId: string) => ['사이트', '알람', siteId] as const,
    summary: (siteId: string) => ['사이트', '요약', siteId] as const,
  },
  inspections: {
    // 점검 기록 관련 쿼리 키들
    getList: ['점검기록조회'] as const,
    getDetail: (id: string) => ['점검기록상세조회', id] as const,
    getBySite: (siteId: string) => ['사이트점검기록조회', siteId] as const,
    createInspection: '점검기록생성',
    updateInspection: '점검기록수정',
    deleteInspection: '점검기록삭제',
  },
};
